import React, { useContext } from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { useOrganization } from 'src/graphql/hooks'
import ThemeContext from 'src/libraries/contexts/Theme'

// =======================================================
// Component
// =======================================================

const PageNav = ({ display, flex }) => {
   const theme = useContext(ThemeContext)
   const { organization } = useOrganization()

   return (
      <View>
         <View
            flex={flex}
            display={display}
            flexFlow="row"
            alignItems="flex-start">
            {/* TODO: Abstract this
            This will change when we decide how to handle Explore "Page" or "App"
            See PR #362 */}
            {organization.slug !== 'gns3' && (
               <NavLink to="/explore">
                  <View paddingRight="25px">
                     <Text
                        size="1.5[a-d] 2[e-f]"
                        color={theme.globalNavTextColor}
                        weight="medium">
                        Explore
                     </Text>
                  </View>
               </NavLink>
            )}
            {organization.globalNavLinks.map((link) => {
               if (link.__typename === 'NavExternalLinkElement') {
                  return (
                     <a key={link.id} href={link.url} target="_blank" rel="noopener noreferrer">
                        <View paddingRight="25px">
                           <Text
                              size="1.5[a-d] 2[e-f]"
                              color={theme.globalNavTextColor}
                              weight="medium">
                              {link.name}
                           </Text>
                        </View>
                     </a>
                  )
               }

               return (
                  <NavLink key={link.id} to={link.url}>
                     <View paddingRight="25px">
                        <Text
                           size="1.5[a-d] 2[e-f]"
                           color={theme.globalNavTextColor}
                           weight="medium">
                           {link.name}
                        </Text>
                     </View>
                  </NavLink>
               )
            })}
         </View>
      </View>
   )
}

PageNav.propTypes = {
   display: PropTypes.string.isRequired,
   flex: PropTypes.string.isRequired
}

export default PageNav
